/* ============
 * Reset password
 * ============
 *
 * This is the page for reseting the user password.
 */

import { mapGetters } from 'vuex';
import store from '../../../store';
import auth from '../../../services/auth';
import Forms from '../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        code: {
          value: '',
          type: 'text',
        },
      }),
      twoFactorTimerCount: null,
      resendLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      twoFactorVerificationType: 'twoFactorVerification',
    }),
    isSms() {
      return this.twoFactorVerificationType === 'sms';
    },
    isGoogle() {
      return this.twoFactorVerificationType === 'google';
    },
    mobileNumber() {
      const last3Mobile = localStorage.getItem('mobile_number');
      return `+47*****${last3Mobile}`;
    },
  },

  watch: {
    twoFactorTimerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.twoFactorTimerCount--;
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },

  created() {
    this.twoFactorTimerCount = 30;
    store.dispatch('checkTwoFactorVerification');
  },

  methods: {
    /**
     * Sends the reset password link.
     */
    resend() {
      this.resendLoading = true;
      auth.resendSmsTwoFactorCode(localStorage.user_id)
      .then(() => {
        this.resendLoading = false;
        this.$message({
          message: this.$t('static.smsTwoFactorVerification.verificationCodeSent'),
          type: 'success',
        });
        this.twoFactorTimerCount = 30;
      })
      .catch((errors) => {
        this.resendLoading = false;
        this.form.errorBox = true;
        this.form.recordErrors(errors);
      });
    },

    verify() {
      this.form.loading = true;
      const data = this.form.data();
      data.user_id = localStorage.user_id;
      if (this.isSms) {
        auth.verifySmsTwoFactorCode(data)
        .catch((errors) => {
          this.handleError(errors);
        });
      } else {
        auth.verifyGoogleTwoFactorCode(data)
          .catch((errors) => {
            this.handleError(errors);
          });
      }
    },

    handleError(errors) {
      this.form.loading = false;
      this.form.errorBox = true;
      this.form.recordErrors(errors);
    },

  },

  components: {
    VForm: require('./../../../components/form/form.vue'),
    VLayout: require('./../../../layouts/user/user.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/auth/twoFactorVerification/twoFactorVerification.js